

<div class="row row-cols-1 row-cols-md-2 row-cols-sm-2 pb-3 g-3">
  <div class="col">
    <app-lt-search-card
      [searchTerm]="logSearchTerm"
      label="Log Message"
      inputClass="form-control searchBox1"
      (searchUpdate)="updateSearch($event)"
      (searchClear)="clearSearch($event)">
    </app-lt-search-card>
  </div>

  <div class="col">
    <app-lt-search-card
      [searchTerm]="stackSearchTerm"
      label="Stack Trace"
      inputClass="form-control searchBox2"
      (searchUpdate)="updateSearch($event)"
      (searchClear)="clearSearch($event)">
    </app-lt-search-card>
  </div>
</div>
  
@if(errorsGrid() && errorsGridReady() === true){
  <app-lt-png-table #table
      [showToolbarInput]="true"
      [gridSettingsInput]="errorsGrid()">
      
      <!-- Server ID Header Template -->
      <ng-template appGridTemplate="serverIdHeader" let-column="column">
          <i class="bi bi-server" matTooltip="Server"></i>
      </ng-template>

      <ng-template appGridTemplate="currentStatusName" let-rowData let-column="column" let-value="value" let-rowIndex="rowIndex">
        <div class="d-inline justify-content-center">
          <app-lt-current-status-toggle
              [(value)]="value"
              (statusChange)="updateError(rowData, $event)"
          ></app-lt-current-status-toggle>
          
        </div>
      </ng-template>

      <ng-template appGridTemplate="currentStatusNameFilter" let-column="column">
          <div class="p-2">
            <app-lt-current-status-toggle
                [value]="statusSelectedFilter()"
                (statusChange)="onColumnStatusFilter($event)"
            ></app-lt-current-status-toggle>
            @if(hasStatusFilter()) {
              <div class="mt-1 text-center">
                <button matIconButton (click)="clearStatusFilter()" aria-label="Clear Status Filter" >
                  <mat-icon>filter_alt_off</mat-icon>
                </button>
              </div>
            }
          </div>

      </ng-template>

      <ng-template appGridTemplate="criticalError" let-rowData let-column="column" let-value="value" let-rowIndex="rowIndex">
        <div class="text-center">
          @if(rowData && rowData.criticalError === true && rowData.currentStatusId !== 1){
              <i class="bi bi-x-circle-fill" style="color: red; font-size: 28px; left: 10px"></i>
          }
          @if(rowData && (rowData.criticalError === false || rowData.currentStatusId === 1)){
              <i class="bi bi-check-circle-fill" style="color: green; font-size: 28px; left: 10px"></i>
          }
        </div>
      </ng-template>
      
      <ng-template appGridTemplate="expandedrow" let-rowData let-rowIndex="rowIndex">
          
            @if(rowData && rowData.serviceErrorId){
              <div class="p-3 bg-light border-start border-primary border-3">
                <p><strong>Service Error Id:</strong> {{rowData.serviceErrorId}}</p>
                <p><strong>Server Error Occurred On:</strong> {{rowData.serverId}}</p>
                <br />
                <p><strong>Function:</strong> {{rowData.functionWithin}}</p>
                <p><strong>Full Log Message:</strong> {{rowData.logMessage}}</p>
                <p><strong>Error Stack Trace:</strong> {{rowData.stackTrace}}</p>
                <app-lt-button (click)="navigateToIntegrationsByServer(rowData)" label="Go To Integrations By Server Page"></app-lt-button>
              </div>
            } @else {
              <div class="p-3 text-muted text-center">
                <i class="bi bi-exclamation-triangle"></i>
                No detail data available
              </div>
            }
          
      </ng-template>
    </app-lt-png-table>
} @else {
  <div class="loading-display d-flex justify-content-center align-items-center">
    <app-lt-spinner></app-lt-spinner>
  </div>
} 